export const LINKEDIN_URL = 'https://www.linkedin.com/company/carriercheck/';
export const FACEBOOK_URL = 'https://www.facebook.com/people/Carriercheck/61589814406869/';
